import { r2pEnum } from '../r2pEnum'
const loadStatusEnum = r2pEnum.LoadStatusEnum;

export default class Bin {
    constructor(params) {
        this.map = {};
        this.p = params;
        this.r2p = params.r2pData;
        this.messsages = [];
        this.videoDataLength = 0;
        this.isFirstDraw = true;
        this.sizeSet = false;
        this.videoData = { data: { video: [] } };
        this.curVideoArr = [];
        this.StartImgNum;
        this.imgPos = 0;
        this.secondPhase = 0;
        this.warningsChecked = false;
        this.worker = new Worker('/r2player/static/js/worker.js');//for debug v.aspx in visual studio
        //this.worker = new Worker('https://dev.segoma.com/v/js/r2player/worker.js');//should be on when building for webform
        /*this.worker = new Worker(
            new URL('./worker.js', import.meta.url)
        );*/
        this.worker.onmessage = this.onMessage.bind(this);
        this.notifySecondPhase = this.notifySecondPhase.bind(this);
        this.proccessMessage = this.proccessMessage.bind(this);
        this.drawImg = this.drawImg.bind(this);
        this.drawPos = this.drawPos.bind(this);
        this.removeBg = this.removeBg.bind(this);
        this.context = params.canvas.getContext("2d")
        this.isSecond = params.isSecond
        this.N = 0;
        //this.newArrLength = 0;
        this.secondLoaded = false;
        this.setPoster();
        this.setBinWorker(params);
        this.isDestroyed = false;

        if (this.r2p.hasSecond) {
            this.r2p.PlayerSocket.syncPhaseFunc = this.notifySecondPhase;
        }
    }

    loadRest() {
        this.resetPlayer();
        this.p.startBinPlayer(this.N);
        this.worker.postMessage({ status: loadStatusEnum.load })
    }

    resetPlayer() {
        if (this.StartImgNum) {
            for (const prop in this.map) {
                if (this.map[prop] === this.StartImgNum) {
                    this.drawImg({ resetFrame: +prop });
                    break;
                }
            }
        }
    }

    destroy() {
        this.isDestroyed = true;
        while (this.videoData.data.video.length) {
            const o = this.videoData.data.video.pop();
            o && URL.revokeObjectURL(o.src);
        }
        this.worker.postMessage({ status: loadStatusEnum.clear })
        this.worker.terminate();
    }

    setPoster() {
        if (this.p.poster) {
            //alert('poster')
            this.videoData.data.video.poster = { src: this.p.poster };
            this.drawPos({ realPos: 'poster' });
        }
    }

    setBinWorker(p) {
        this.p.showLoader && this.p.showLoader(true);
        var r2pClone = Object.assign({}, p.r2pData);
        delete r2pClone.PlayerSocket;
        delete r2pClone.playerSync;
        //const workerdata = { status: 'start', ...r2pClone };
        const workerdata = { status: loadStatusEnum.start, ...r2pClone };
        delete workerdata.onload;
        this.worker.postMessage(workerdata);
        delete workerdata.start;
    }


    onMessage(e) {

        if (e.data.galleryImagesInSet) {
            this.p.setSegments(e.data.galleryImagesInSet);
            return;
        }

        if (e.data.currentSet || e.data.currentSet === 0) {
            this.p.setLoadedData(e.data.currentSet, 0);
            return;
        }

        const ts = e.data.TotalSets;
        if (ts) {
            this.p.setSetsNum(ts);
            return;
        }

        const StartImgNum = e.data.StartImgNum;
        if (StartImgNum) {
            this.StartImgNum = StartImgNum;
            return;
        }

        this.phase = e.data.phase;

        if (this.r2p.hasSecond && this.phase > 1) {
            if (this.phase > this.secondPhase) {
                this.messsages[this.phase] = e;
            }
            else {
                this.proccessMessage(e);
            }
        }
        else {
            this.proccessMessage(e);
        }


        if (this.isSecond && this.phase > 1) {
            this.r2p.PlayerSocket.r2pPhaseSync(this.phase);
        }
    }

    notifySecondPhase(phase) {
        this.secondPhase = phase;
        const mes = this.messsages[phase];
        if (mes) {
            console.log('proccess: ' + (this.r2p.hasSecond ? 'first' : 'second') + ', phase: ' + this.phase + ' - from arr')
            this.proccessMessage(mes);
        }
        delete this.messsages[phase];
    }

    proccessMessage(e) {

        this.N = e.data.N;

     

        if (this.isDestroyed) return;

        this.setImages(e.data);

        if (this.p.notifyImgLoaded) {
            const { img, callback } = this.p.notifyImgLoaded
            if (e.data.video[img] && callback) {
                callback({ img })
                delete this.p.notifyImgLoaded
            }
        }
        
        if (this.r2p.isGallery) {
            this.drawImg({ resetFrame: this.StartImgNum || 0 });
            this.p.galleryItemLoaded();
            return;
        }
        this.realPos && (this.imgPos = +(Object.keys(this.map).find(_ => this.map[_] === this.realPos)));
        this.p.setLoadedData(e.data.N, e.data.d.length)

        if (this.r2p.maxImages && this.r2p.maxImages.includes(e.data.d.length)) {
            return;
        }

        if (e.data.phase === 1) {
            this.p.firstPhaseLoaded();
            if (this.r2p.preload) {
                return;
            }
            !this.r2p.preloadAll && !this.isSecond && this.p.startBinPlayer(e.data.N, e.data.d.length);
        }
        else if (e.data.phase > 1) {
            !this.isSecond && this.p.updateBinPlayer(e.data.N, e.data.d.length);
        }

        if (e.data.isLast && this.isSecond) {
            this.secondLoaded = true;
        }

        setTimeout(_ => this.worker.postMessage({ status: loadStatusEnum.load }), 0)
    }


    drawImg({ resetFrame, frames }) {
        const length = this.videoDataLength;
        const last = length - 1;

        const { startWithImg } = this.r2p
        if (startWithImg) {
            if (this.videoData.data.video[startWithImg]) {
                this.realPos = startWithImg;
                this.imgPos = +(Object.keys(this.map).find(_ => this.map[_] === startWithImg));
                delete this.r2p.startWithImg;
                this.p.playPause(false)
            }
            else {
                return;
            }
        }
        else {
            if (resetFrame || resetFrame === 0) {
                if (resetFrame === -1) {
                    this.imgPos = last;
                }
                else {
                    this.imgPos = resetFrame;
                }
            }
            else {
                const po = this.imgPos + frames;
                if (po < 0) {
                    this.imgPos = length - 1;
                }
                else {
                    this.imgPos = po;
                }

                this.imgPos = this.imgPos % length;
                this.realPos = this.map[this.imgPos];
            }
        }


        this.p.setDebugPos && this.p.setDebugPos({ imgPos: this.imgPos, realPos: this.realPos })

        this.drawPos({ realPos: this.realPos, imgPos: this.imgPos });
        if (this.r2p.hasSecond) {
            this.r2p.PlayerSocket.r2pPosSync(this.realPos, this.imgPos, this.videoDataLength);
        }
    }

    getPosByPercent(index, total) {
        var percent = index / total;
        var thisPercent = this.videoDataLength * percent;
        var pos = Math.round(thisPercent);
        pos = pos === this.videoDataLength ? this.videoDataLength - 1 : pos;
        var realPos = this.map[pos];
        //console.log('realPos lag: ' + realPos)
        if (!realPos) {
            ;
        }
        return realPos;
    }

    drawPos({ realPos, index, total, imgPos }) {

        if (!imgPos && realPos && realPos !== 'poster') {
            this.imgPos = this.curVideoArr.filter(x => x).findIndex(x => x?.orgNum === realPos);
        }

        if (this.isSecond && total && total !== this.videoDataLength) {
            realPos = this.getPosByPercent(index, total);
        }
        var d = this.videoData.data.video[realPos];

        return new Promise((resolve, reject) => {
            if (!d) return;// reject('img not in current sets');

            if (!d.img) {
                var img = new Image()

                img.src = d.src;
                d.img = img;
                img.onload = _ => {
                    URL.revokeObjectURL(d.src);
                    d.src = null;
                    if (!this.sizeSet) {
                        //console.log('imgPos: ' + imgPos)
                        this.sizeSet = true;
                        this.p.canvas.width = d.img.naturalWidth;
                        this.p.canvas.height = d.img.naturalHeight;
                    }
                    if (d.img.naturalWidth !== this.p.canvas.width) {
                        this.p.canvas.width = d.img.naturalWidth;
                        this.p.canvas.height = d.img.naturalHeight;
                    }


                    this.removeBg();
                    this.context.drawImage(d.img, 0, 0, this.p.canvas.width, this.p.canvas.height);
                    if (this.isFirstDraw) {
                        this.isFirstDraw = false;
                        this.p.r2pData.isPng && this.p.firstDrawHandler && this.p.firstDrawHandler();
                    }
                    setTimeout(resolve, 0)
                    //console.log(`realPos load ${this.isSecond ? 2 : 1}: ${realPos}`)
                }
            }
            else {
                if (d.img.naturalWidth !== this.p.canvas.width) {
                    //alert();
                }
                this.removeBg();
                this.context.drawImage(d.img, 0, 0, this.p.canvas.width, this.p.canvas.height)
                //console.log(`realPos cache ${this.isSecond ? 2 : 1}: ${realPos}`)
                setTimeout(resolve, 0)
            }
        })

    }


    removeBg() {
        if (this.p.r2pData.isPng) {
            this.context.clearRect(0, 0, this.p.canvas.width, this.p.canvas.height);
            !this.bgRemoved && (this.p.canvas.style.backgroundImage = '');
            this.bgRemoved = true;
        }
    }

    setImages(d) {

        let index = 0;
        let arr = [];

        d.video.forEach((x, i) => {
            if (!this.curVideoArr[i]) {
                var img = {};
                img.src = x;
                img.orgNum = i;
                this.curVideoArr[i] = img
            }
            arr.push({ index, i });
            this.map[index++] = i;
        })
        this.videoDataLength = index;

        if (!this.isSecond) {
            var l = this.curVideoArr[this.realPos];

            let newIngPos = 0;

            if (l) {
                newIngPos = arr.findIndex(x => x && x.i === l.orgNum)
            }

            this.imgPos = newIngPos;
        }

        this.videoData.data.video = this.curVideoArr;
    }

    terminate() {
        this.worker.terminate();
    }
}

